"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActiveData = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../constants");
var _useCookie = require("../../../hooks/useCookie");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } /*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * Only if `ACTIVE_DATA_ENABLED` is true, and only if not already loaded, asynchronously
 * request/load/execute the script required for DW Active Data analytics to operate.
 * @returns {Promise<boolean>}
 */
function importDwActiveData() {
  return _importDwActiveData.apply(this, arguments);
}
function _importDwActiveData() {
  _importDwActiveData = (0, _asyncToGenerator2.default)(function* () {
    var _globalThis$dw7;
    if (!_constants.ACTIVE_DATA_ENABLED || (_globalThis$dw7 = globalThis.dw) !== null && _globalThis$dw7 !== void 0 && _globalThis$dw7.ac) {
      return _constants.ACTIVE_DATA_ENABLED;
    }
    if (typeof globalThis.dw !== 'object' || globalThis.dw === null) {
      globalThis.dw = {};
    }

    // Resolve the loading/import promise with `true`, if `globalThis.dw?.ac` is
    // defined after successful loading. Resolve with `false`, if loading fails.
    // @ts-ignore
    return Promise.resolve().then(() => _interopRequireWildcard(require("../../assets/js/active-data"))).then(() => {
      var _globalThis$dw8;
      return typeof ((_globalThis$dw8 = globalThis.dw) === null || _globalThis$dw8 === void 0 ? void 0 : _globalThis$dw8.ac) !== 'undefined';
    }, () => false);
  });
  return _importDwActiveData.apply(this, arguments);
}
function logError(method, error) {
  console.error(`ActiveData ${method} error'`, {
    namespace: `useActiveData.${method}`,
    additionalProperties: {
      error
    }
  });
}
function trackSearchHits(productSearchResult) {
  var _globalThis$dw;
  const ac = (_globalThis$dw = globalThis.dw) === null || _globalThis$dw === void 0 ? void 0 : _globalThis$dw.ac;
  productSearchResult.hits.map(({
    productId
  }) => {
    var _ac$_capture;
    return ac === null || ac === void 0 ? void 0 : (_ac$_capture = ac._capture) === null || _ac$_capture === void 0 ? void 0 : _ac$_capture.call(ac, {
      id: productId,
      type: 'searchhit'
    });
  });
}
const useActiveData = () => {
  const {
    isMarketingAllowed
  } = (0, _useCookie.useCookie)();
  return {
    sendViewProduct(category, product, type) {
      return (0, _asyncToGenerator2.default)(function* () {
        try {
          const canTrack = yield importDwActiveData();
          if (!isMarketingAllowed) return;
          if (canTrack) {
            var _globalThis$dw2, _ac$_scheduleDataSubm;
            const ac = (_globalThis$dw2 = globalThis.dw) === null || _globalThis$dw2 === void 0 ? void 0 : _globalThis$dw2.ac;
            if (category !== null && category !== void 0 && category.id) {
              var _ac$applyContext;
              ac === null || ac === void 0 ? void 0 : (_ac$applyContext = ac.applyContext) === null || _ac$applyContext === void 0 ? void 0 : _ac$applyContext.call(ac, {
                category: category.id
              });
            }
            if (product !== null && product !== void 0 && product.id) {
              var _ac$_capture2;
              ac === null || ac === void 0 ? void 0 : (_ac$_capture2 = ac._capture) === null || _ac$_capture2 === void 0 ? void 0 : _ac$_capture2.call(ac, {
                id: product.id,
                type: type
              });
            }
            ac === null || ac === void 0 ? void 0 : (_ac$_scheduleDataSubm = ac._scheduleDataSubmission) === null || _ac$_scheduleDataSubm === void 0 ? void 0 : _ac$_scheduleDataSubm.call(ac);
          }
        } catch (err) {
          logError('sendViewProduct', err);
        }
      })();
    },
    sendViewSearch(searchData, productSearchResult) {
      return (0, _asyncToGenerator2.default)(function* () {
        try {
          const canTrack = yield importDwActiveData();
          if (!isMarketingAllowed) return;
          if (canTrack) {
            var _globalThis$dw3, _ac$applyContext2, _ac$_scheduleDataSubm2;
            const ac = (_globalThis$dw3 = globalThis.dw) === null || _globalThis$dw3 === void 0 ? void 0 : _globalThis$dw3.ac;
            ac === null || ac === void 0 ? void 0 : (_ac$applyContext2 = ac.applyContext) === null || _ac$applyContext2 === void 0 ? void 0 : _ac$applyContext2.call(ac, {
              searchData
            });
            trackSearchHits(productSearchResult);
            ac === null || ac === void 0 ? void 0 : (_ac$_scheduleDataSubm2 = ac._scheduleDataSubmission) === null || _ac$_scheduleDataSubm2 === void 0 ? void 0 : _ac$_scheduleDataSubm2.call(ac);
          }
        } catch (err) {
          logError('sendViewSearch', err);
        }
      })();
    },
    sendViewCategory(searchData, category, productSearchResult) {
      return (0, _asyncToGenerator2.default)(function* () {
        try {
          const canTrack = yield importDwActiveData();
          if (!isMarketingAllowed) return;
          if (canTrack) {
            var _globalThis$dw4, _ac$_scheduleDataSubm3;
            const ac = (_globalThis$dw4 = globalThis.dw) === null || _globalThis$dw4 === void 0 ? void 0 : _globalThis$dw4.ac;
            if (category !== null && category !== void 0 && category.id) {
              var _ac$applyContext3;
              ac === null || ac === void 0 ? void 0 : (_ac$applyContext3 = ac.applyContext) === null || _ac$applyContext3 === void 0 ? void 0 : _ac$applyContext3.call(ac, {
                category: category.id,
                searchData
              });
            }
            trackSearchHits(productSearchResult);
            ac === null || ac === void 0 ? void 0 : (_ac$_scheduleDataSubm3 = ac._scheduleDataSubmission) === null || _ac$_scheduleDataSubm3 === void 0 ? void 0 : _ac$_scheduleDataSubm3.call(ac);
          }
        } catch (err) {
          logError('sendViewCategory', err);
        }
      })();
    },
    trackPage(siteId, localeId, currency) {
      return (0, _asyncToGenerator2.default)(function* () {
        try {
          const canTrack = yield importDwActiveData();
          if (!isMarketingAllowed) return;
          if (canTrack) {
            var _globalThis$dw5, _ac$_setSiteCurrency;
            const ac = (_globalThis$dw5 = globalThis.dw) === null || _globalThis$dw5 === void 0 ? void 0 : _globalThis$dw5.ac;
            if (!(ac !== null && ac !== void 0 && ac._analytics)) {
              var _ac$setDWAnalytics, _globalThis$dw6, _globalThis$dw6$__dwA, _globalThis$dw6$__dwA2;
              ac === null || ac === void 0 ? void 0 : (_ac$setDWAnalytics = ac.setDWAnalytics) === null || _ac$setDWAnalytics === void 0 ? void 0 : _ac$setDWAnalytics.call(ac, (_globalThis$dw6 = globalThis.dw) === null || _globalThis$dw6 === void 0 ? void 0 : (_globalThis$dw6$__dwA = _globalThis$dw6.__dwAnalytics) === null || _globalThis$dw6$__dwA === void 0 ? void 0 : (_globalThis$dw6$__dwA2 = _globalThis$dw6$__dwA.getTracker) === null || _globalThis$dw6$__dwA2 === void 0 ? void 0 : _globalThis$dw6$__dwA2.call(_globalThis$dw6$__dwA, `/mobify/proxy/sfra-api/on/demandware.store/Sites-${siteId}-Site/${localeId}/__Analytics-Start`));
            }
            ac === null || ac === void 0 ? void 0 : (_ac$_setSiteCurrency = ac._setSiteCurrency) === null || _ac$_setSiteCurrency === void 0 ? void 0 : _ac$_setSiteCurrency.call(ac, currency);
          }
        } catch (err) {
          logError('trackPage', err);
        }
      })();
    }
  };
};
exports.useActiveData = useActiveData;